
import React, { useState, useEffect } from 'react';
import { pubCall } from "../utils/PubSub";
import { drawPrice } from "../utils/Utils";
import { showError} from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import Label from "../ui/Label";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";

const ProcessingPreview = (props) => {
    const { 
        data = [],
        controller = "",
        selected = null,
        setSelectedList = () => {},
        callback = () => {},
        view = false,
        setView = () => {},
        row_key = "order_id",
        route = ""
    } = props;

    const column = [
        {key: "supplier_name", width: 200,  title: "Cust", align: "left", render: (e, f) => {
            return f?.customer?.name;
        }},
        {key: "quantity", width: 65,  title: "Quantity", align: "right"},
        {key: "invoice_price", width: 100,  title: "Price", align: "right", render: (e, f) => {
            return (<div>{drawPrice(f.invoice_price, true)}</div>)
        }},
        {key: "title", width: 400, title: "Title", align: "left"},
        {key: "primary_code", width: 150,  title: "ISBN", align: "left"},
        {key: "age", width: 40,  title: "Age", align: "left"},
        {key: "cancel_date", width: 100,  title: "Cancel Date", align: "left"},
        {key: "supplier", width: 80,  title: "Supplier", align: "right"},
        {key: "tmpstat", width: 200,  title: "TmpStat", align: "left"},
        {key: "clerk_code", width: 100,  title: "Clerk Code", align: "left"},
        {key: "pubstock_supplier", width: 50,  title: "PSSup", align: "left"},
        {key: "pubstock_onhand", width: 50,  title: "o/h", align: "left"},
        {key: "pubstock_onorder", width: 50,  title: "o/o", align: "left"},
    ]

    const next = (_rows = 1) => {
        if (data.length === 0) { setSelectedList({}); return; }
        const index = data.findIndex(item => item?.[row_key] === selected?.[row_key]);
        const nextIndex = Math.min(index + _rows, data.length - 1);
        setSelectedList(data[nextIndex]);
    };

    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelectedList({}); return; }
        const index = data.findIndex(item => item?.[row_key] === selected?.[row_key]);
        const prevIndex = Math.max(index - _rows, 0);
        setSelectedList(data[prevIndex]);
    };

    useEffect(() => {
        if (!view) { return; }

        const actions = [
            { key: KBD.ESCAPE, action: () => { cancelView() } },
            { key: KBD.ARROW_DOWN, action: () => { next() } },
            { key: KBD.ARROW_UP, action: () => { prev() } }
        ]

        const cleanup = listen(
            controller,
            route,
            actions,
            false,
            [
                KBD.ESCAPE,
                KBD.ARROW_DOWN,
                KBD.ARROW_UP
            ]
            
        );
        return cleanup;
    }, [view, controller, route, data, selected, row_key]);

    const cancelView = () => {
        callback(false);
    }

    return (
        <div style={{ padding: "0px" }} onDoubleClick={() => {  if (!view) setView(true) }}>
            <Label style={{ "textAlign": "left" }}>&nbsp;Orders Preview <em><small>(First 10 matches only - Press View or Enter to view entire order)</small></em></Label>
            <VirtualTable
                data={data}
                columns={column}
                current={selected}
                onRowClick={(item) => { setSelectedList(item) }}
                row_key={row_key}
                height={(view) ? 420 : 200}    
                offset={650}
                edit={(view) ? true : false}
            />
        </div>
    )
}

export default ProcessingPreview;